import { Component } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';

import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';

@Component({
    templateUrl: 'get-started.html',
    standalone: false
})

export class EmployerGetStartedPage {

  readonly desktopWidthContent: string = scrollContentWidth.LARGE;

  constructor(
    private navCtrl: CustomNavController,
    public windowService: WindowService
  ) {}

  goToPage(page) {
    this.navCtrl.navigateForward(page);
  }

}
